import {$vfm} from '@/libs/vueFinalModal';
/**
 * Xử lý hiển thị popup
 */
class PopupUtil {
  /**
   * Đối tượng cache lại các component popup
   */
  _components = {};

  /**
   * Danh sách các popup đang hiển thị
   * key: tên popup
   * value: instance
   */
  _visible = {};

  /**
   * Mở popup
   * @param {string} name : Tên định danh
   * @param {object} params : tham số
   */
  async show(name, params) {
    if (!name) throw 'name is required';
    const ps = params || {};
    ps.name = name;

    const popup = await $vfm.show({component: name}, ps);
    console.log(`Popup name: ${name}`);
    return popup;
  }

  /**
   * Đóng popup theo name
   */
  hide(name) {
    $vfm.hide(name);
  }
  /**
   * Đóng tất cả popup đang mở
   */
  hideAll() {
    $vfm.hideAll();
  }
  
}

export default new PopupUtil();
